<script setup>
  import { ref } from 'vue'

  const showPlatformDialog = ref(false)
  const externalPlatform = ref([])

  const showDialog = (platform) => {
    showPlatformDialog.value = true
    externalPlatform.value = platform
  }

  const openExternalPlatform = () => {
    if (externalPlatform.value?.external_platform_url) {
      window.open(externalPlatform.value?.external_platform_url, '_blank')
    }
    showPlatformDialog.value = false
  }

  defineExpose({
    showDialog,
    showPlatformDialog,
  })
</script>

<template>
  <Dialog
    modal
    v-model:visible="showPlatformDialog"
    :draggable="false"
    dismissableMask
    class="md:max-w-[500px] xs:max-w-[320px] sm:max-w-[400px]"
    header="Publicación Externa"
  >
    <div
      class="flex flex-col relative gap-3 text-center items-center select-none"
    >
      <div
        class="border border-neutral-200 rounded-md flex items-center justify-center gap-5 px-5 py-2 mt-2"
      >
        <img
          class="rounded-full border-2 border-gray-600 w-16"
          :src="externalPlatform?.logo_url"
          :alt="externalPlatform?.name"
        />
        <div class="flex flex-col">
          <p class="text-gray-200 text-sm select-none">Servicio externo de:</p>
          <p class="select-none">{{ externalPlatform?.name }}</p>
        </div>
      </div>

      <div class="px-4 md:px-10 mt-5 select-none">
        Esta publicación es un enlace externo que opera fuera de Tickea ¿deseas
        continuar?
      </div>

      <div class="mt-5 mb-2 gap-10 platform-btn" @click="openExternalPlatform">
        <p>Continuar</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="white"
          width="24"
        >
          <title>open-in-new</title>
          <path
            d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
          />
        </svg>
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
  .platform-btn {
    @apply flex items-center justify-between dark:bg-primary-500 bg-[#1C1C1C] text-white font-semibold py-3 px-6 rounded-xl transition-all hover:shadow-lg hover:shadow-[#dd99a9] dark:hover:shadow-primary-700;

    user-select: none;
    &.disabled {
      pointer-events: none;
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
</style>
